import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { fetchSessionUser, selectUser } from '../../../store/session'
import { isJustGiving } from '../../../lib/environment'

import Everydayhero from './Everydayhero'
import JustGiving from './JustGiving'

import FlatModal from '../../ui/FlatModal'
import Section from 'constructicon/section'

class Login extends React.Component {
  componentDidMount () {
    this.checkLoggedIn(this.props)
  }

  componentWillReceiveProps (nextProps) {
    this.checkLoggedIn(nextProps)
  }

  checkLoggedIn (props) {
    const {
      location,
      router,
      user = {}
    } = props

    if (user.token) {
      const { redirect = `/fundraising/${router.params.slug}` } = location.query
      router.push(redirect)
    }
  }

  render () {
    const { fetchSessionUser, router, styles } = this.props

    return (
      <FlatModal
        contentLabel='Login'
        isOpen
        onRequestClose={() => router.push(`/fundraising/${router.params.slug}`)}
        styles={styles.modal}>
        <Section>
          {isJustGiving()
            ? <JustGiving onSuccess={fetchSessionUser} />
            : <Everydayhero onSuccess={fetchSessionUser} />}
        </Section>
      </FlatModal>
    )
  }
}

const mapState = state => ({
  user: selectUser(state)
})

const mapDispatch = { fetchSessionUser }

export default compose(
  connect(mapState, mapDispatch),
  withStyles(styles),
  withRouter
)(Login)
